import { OnboardingProvider } from '@packlink/packlink-sdk';
import { EcommerceAlias } from '@Integrations/constants/ecommerce';
import { ActivateStartFlow } from '../ActivateStartFlow';
import { FC } from 'react';

export const TikTokActivateStartFlow: FC = (): JSX.Element => (
    <ActivateStartFlow provider={OnboardingProvider.SHIPENGINE_TIKTOK} integrationAlias={EcommerceAlias.TikTok} />
);
